
export const getUserToken = () => {
    const user = JSON.parse(sessionStorage.getItem("CIBA_USER"));
    if (user && user.token) {
      return user.token;
    }
  
    return null;
  };
  
  export const getUser = () => {
    const user = JSON.parse(sessionStorage.getItem("CIBA_USER"));
    if (user && user.user) {
      return user.user;
    }
  
    return null;
  };
  

  